// extracted by mini-css-extract-plugin
export var sectionHeading = "sectionHeading-module--sectionHeading--eKzYk";
export var sectionHeadingOrphan = "sectionHeading-module--sectionHeadingOrphan--bOqRL";